/**
 * @fileoverview A dot expressing the current value. This overlays on
 * top of the quartile box.
 */

import React from 'react'

// A dot expressing the current value
export default function CurrentDot({ x, y, width }) {
  const radius = Math.min(6, Math.max(width / 5, 3))
  const centerX = x + width * 0.5

  return (
    <circle
      r={radius}
      cx={centerX}
      cy={y}
      fill="white"
      stroke="black"
      strokeWidth="1.5"
    />
  )
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/easing-box/current-dot.js